import script from "./CrmEngagementPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CrmEngagementPanel.vue?vue&type=script&setup=true&lang=js"

import "./CrmEngagementPanel.vue?vue&type=style&index=0&id=6d5c803c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5c803c"]])

export default __exports__